export default {
  home: {
    modal_alert: {
      title: "Alerta de fraude",
      content: "<p>Prezado Cliente, reforçamos que o domínio de E-mail utilizado pela Aspecir Empréstimos é o “@aspeciremprestimos.com.br”. Esteja sempre alerta! Verifique se o remetente possui esse domínio.</p><br /><p>A ASPECIR não se responsabiliza por E-mails que não possuam este domínio, bem como, não reconhece pagamentos efetuados em conta bancária de terceiros que, supostamente, sejam destinados para a quitação de dívidas com esta Instituição.</p><p>A ASPECIR não solicita nenhum pagamento antecipado para a realização de empréstimos.</p><br /><p>Desconfie de qualquer prática incomum, principalmente de e-mails enviados com extensão pública, como: @outlook, @gmail, @hotmail, @yahoo, etc. Em caso de dúvidas, ligue para a nossa Central de Atendimento: (51) 3228.1661.</p>",
      exit_button: "Fechar",
    },
    browser_title: "Aspecir Empréstimos - Instituição financeira autorizada pelo banco central do brasil",
    banner: {
      subtitle: "Instituição financeira autorizada pelo banco central do brasil"
    },
    about_us: {
      title: "Sobre a instituição",
      content: "Aspecir - Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte Ltda., autorizada pelo Banco Central do Brasil desde setembro de 2002, é uma instituição que faz parte do Grupo Aspecir, composto por seguradora e entidade de previdência, que possuem mais de 100 anos de atuação, genuinamente gaúchas, atuando junto à órgãos públicos e empresas privadas, busca a Sociedade de Crédito ao Microempreendedor, alcançar o público dos micro e pequenos empresários, sendo estas pessoas físicas ou jurídicas, dos setores da indústria, comércio ou prestação de serviços, formais ou informais, tendo como seu principal objetivo a disponibilização de produtos e serviços para esses pequenos empreendedores e a missão de oportunizar o acesso e utilização do sistema financeiro, contribuindo para que o crescimento atinja uma maior parcela da população, oferecendo linhas de crédito exclusivas para ampliação, modernização, aquisição de equipamentos e máquinas, capital de giro, legalização da empresa ou até mesmo desenvolvimento de novos empreendimentos."
    },
    news: {
      title: "Notícias em destaque",
      button: "Mais Notícias",
      continue_button: "Continue lendo..."
    },
    products: {
      title: "Nossos Produtos",
      products: [
        {
          image: "/assets/imgs/plan-assistenciafinanceira.png",
          title: "Empréstimos",
          description: "Labore ea est voluptate sit anim laboris duis pariatur in."
        },
        {
          image: "/assets/imgs/plan-seguro.png",
          title: "Financiamento",
          description: "Labore ea est voluptate sit anim laboris duis pariatur in."
        },
        {
          image: "/assets/imgs/plan-microseguro.png",
          title: "Microseguro",
          description: "Labore ea est voluptate sit anim laboris duis pariatur in."
        }
      ]
    },
    contact: {
      title: "Entre em contato",
      address: {
        label: "Onde Estamos"
      },
      contact: {
        label: "Contato",
        number_info: "Em dias úteis, das 9h às 18h."
      },
      ouvidoria: {
        label: "Ouvidoria",
        number: "0800 067 5757",
        url: "https://www.abscm.com.br/ouvidoria"
      },
      complaint: {
        label: "Denúncia",
        email: "denuncia@aspeciremprestimos.com.br"
      },
      socials: {
        label: "Siga-nos em:",
        facebook: "",
        instagram: "",
        linkedin: "",
        youtube: "",
        twitter: ""
      }
    }
  },
  products: {
    browser_title: "Aspecir Empréstimos - Nossos Produtos",
    title: "Nossos principais produtos",
    content: "<p>Atualmente, a Aspecir SCMEPP Ltda. possui cinco linhas de negócios. São elas: Desconto de Recebíveis, Capital Fixo com Alienação Fiduciária, Crédito Consignado, Crédito Produtivo Individual (PF e PJ) e Microseguro.</p><h4>Desconto de Recebíveis</h4><p>Consiste em uma forma de antecipar os recebíveis para os estabelecimentos conveniados. Com este produto, os estabelecimentos recebem o dinheiro no dia seguinte. As taxas são variáveis, pois dependem do valor a ser antecipado, do momento e necessidade da operação, do tipo de estabelecimento, do histórico evolutivo da empresa cliente, de negociações com a Aspecir e se o cliente é prospecção ou manutenção.</p><p>Esta modalidade visa atender a necessidade de capital de giro dos estabelecimentos.</p><h4>Capital Fixo com Alienação Fiduciária</h4><p>Consiste em financiar a compra de um pequeno meio de transporte. A garantia é o próprio veículo.</p><h4>Crédito Consignado</h4><p>Destinado a aposentados e pensionistas, esta modalidade consiste na oferta de crédito consignado com desconto em folha junto aos Órgãos conveniados, atuando através de entidades que desenvolvem atividades profissionais com aposentados e pensionistas, a fim de, iniciar ou alavancar seus próprios negócios, como uma forma de facilitar o acesso ao crédito, especialmente por viabilizar empreendimentos de natureza profissional, formal ou informal, possibilitando empréstimos com taxas de juros muito menores que as praticadas usualmente pelo mercado financeiro.</p><h4>Crédito Produtivo Individual – Pessoa Física ou Jurídica</h4><p>O crédito individual busca atender microempreendedores com capacidade de oferecer um avalista pessoal, buscando o crescimento da carteira de créditos e com a realização de uma análise mais profunda.</p><p>O crédito individual é um empréstimo dirigido para financiar uma porcentagem do capital de giro da microempresa que atenda às condições estabelecidas pelas Políticas da Aspecir SCMEPP Ltda., observando-se o tamanho do negócio, o volume das vendas, a necessidade manifestada de capital de giro, a capacidade de pagamento, além do caráter do cliente potencial, entre outras características.</p>"
  },
  news: {
    browser_title: "Aspecir Empréstimos - Últimas notícias",
    title: "Últimas notícias",
    continue_button: "Continue lendo..."
  },
  transparency: {
    browser_title: "Aspecir Empréstimos - Transparência",
    title: "Transparência",
    texts: [
      { 
        title: "Governança Corporativa",
        text:"<p>A estrutura de covernança corporativa da Aspecir é responsável por definir estratégias e tomar decisões, assegurando uma geração de valor sustentável para a instituição e a sociedade em geral.</p><p>A Aspecir opta pelas boas práticas de Governança Corporativa, adotando como principais diretrizes a transparência, a prestração de contas, a honestidade e a responsabilidade corporativa, proporcionando aos sócios a gestão estratégica e o monitoramento da direção executiva e de seus processos internos.</p>",
      },
      { 
        title: "Responsabilidade Social",
        text:"<p>Ter responsabilidade social implica pensa em desenvolver-se de forma sustentável, criar uma estratégia de desenvolvimento econômico em sintonia com as demandas e questões sociais e a utilizar, de forma cosnciente, os recursos disponíveis no meio ambiente, permitindo a satisfação da necessidade atual sem comprometer a possibilidade das gerações futuras de atenderem suas próprias necessidades.</p><p>A Política de Responsabilidade Social e Ambiental da Aspecir, alinhada com a Missão, a Visão, os Valores e o Código de Ética da instituição, reafirma o compromisso histórico da Aspecir com o desenvolvimento sustentável do país.</p><p>Responsabilidade Social e Ambiental para a Aspecir é valorizar e garantir a integração das dimensões social e ambiental em sua estratégia, políticas, práticas e procedimentos, em todas as suas atividades e no relacionamento com seus diversos públicos.</p>",
      }
    ],
    file_frame: {
      file_description: "Descrição",
      file_name: "Nome: ",
      file_type: "Tipo: "
    }
  },
  work_apply: {
    browser_title: "Aspecir Empréstimos - Trabalhe conosco",
    title: "Trabalhe conosco",
    description: "Venha integrar nossa equipe. O Grupo Aspecir está em constante expansão.<br />Anexe o seu currículo e nós entraremos em contato, assim que surgir uma oportunidade na sua área.",
    form: {
      input_name: {
        placeholder: "Nome",
        validation_required: "Por favor, informe seu nome."
      },
      input_email: {
        placeholder: "E-mail",
        validation_required: "Por favor, informe seu e-mail.",
        validation_type: "Este não é um e-mail válido!"
      },
      input_file: {
        empty: "Arraste o arquivo PDF do seu currículo para este campo ou clique no botão abaixo.",
        valid: "Arquivo PDF válido!",
        invalid: "Apenas arquivos em PDF são permitidos!",
        button: "Selecionar currículo",
        selected: "Currículo selecionado:"
      },
      submit: "Enviar"
    },
    messages: {
      file_required: "Para validar a sua candidatura, vocẽ precisa inserir o seu currículo.",
      submit_success: "Você se candidatou com sucesso!",
      submit_error: "Ocorreu um problema com a sua submissão, por favor, tente novamente."
    }
  }
}